import { render, staticRenderFns } from "./BarPointPositifConsultationsMDTChart.vue?vue&type=template&id=8f511456&"
import script from "./BarPointPositifConsultationsMDTChart.vue?vue&type=script&lang=ts&"
export * from "./BarPointPositifConsultationsMDTChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports